import styled from "styled-components";
import {getLineHeight, parseSize, transformSize} from "../../../common/generic-react.functions.js";
import {LabelContainer} from "../../atoms/label/label.styles.js";
export const ImageUploaderContainer = styled.div.withConfig({
  displayName: "image-uploaderstyles__ImageUploaderContainer",
  componentId: "sc-fe66t4-0"
})(["", " background:#2895f105;", ""], {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  borderRadius: "0.25rem",
  position: "relative",
  width: "100%",
  height: "100%",
  color: "var(--tertiaryColor)",
  borderWidth: "1px",
  borderStyle: "dashed",
  borderColor: "var(--tertiaryColor)"
}, ({
  hasResult
}) => hasResult && {
  display: "none"
});
export const ImageContainer = styled.div.withConfig({
  displayName: "image-uploaderstyles__ImageContainer",
  componentId: "sc-fe66t4-1"
})(["width:", ";height:", ";", " ", " ", " ", ",", "{", "}"], ({
  width
}) => width, ({
  height
}) => height, ({
  disabled
}) => disabled ? {
  cursor: "not-allowed",
  opacity: "0.5"
} : {
  cursor: "copy"
}, ({
  border
}) => border && {
  borderWidth: "1px",
  borderRadius: "0.25rem"
}, {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  position: "relative"
}, ImageUploaderContainer, LabelContainer, ({
  disabled
}) => disabled ? {
  cursor: "not-allowed"
} : {
  cursor: "copy"
});
export const ImageContentContainer = styled.img.withConfig({
  displayName: "image-uploaderstyles__ImageContentContainer",
  componentId: "sc-fe66t4-2"
})(["max-width:", ";max-height:", ";", " ", ""], ({
  width
}) => width, ({
  height
}) => height, ({
  hasResult
}) => !hasResult && {
  display: "none"
}, {
  width: "auto",
  height: "auto",
  borderWidth: "1px",
  borderStyle: "solid",
  borderColor: "var(--tertiaryColor)"
});
export const ImageUploaderMainContainer = styled.div.withConfig({
  displayName: "image-uploaderstyles__ImageUploaderMainContainer",
  componentId: "sc-fe66t4-3"
})(["max-width:", ";input{", "}", "{", "}", "{", "}.input__error{font-size:", ";line-height:", ";", "}"], ({
  width
}) => width, {
  position: "absolute",
  display: "none"
}, LabelContainer, ({
  errorMessage
}) => errorMessage && {
  color: "var(--errorColor)"
}, ImageUploaderContainer, ({
  errorMessage
}) => errorMessage && {
  borderColor: "var(--errorColor)"
}, ({
  size
}) => parseSize(transformSize(size, -1)), ({
  size
}) => getLineHeight(transformSize(size, -1)), {
  marginTop: "0.25rem",
  color: "var(--errorColor)"
});
